import { inject, Injectable } from '@angular/core';
import { SmartRiskService } from '@app/core/services';
import * as fromRoot from '@app/store/reducers';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { throwError } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';

import { CurrenciesActions } from '../actions';
import { getAllCurrencies, getFxRatesHistories } from '../reducers';

@Injectable()
export class CurrencyEffects {
  readonly actions$ = inject(Actions);
  readonly store = inject<Store<fromRoot.State>>(Store);
  readonly smartRiskService = inject(SmartRiskService);

  loadCurrencies$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CurrenciesActions.loadCurrencies),
      withLatestFrom(this.store.select(getAllCurrencies)),
      switchMap(() =>
        this.smartRiskService.getAllCurrencies().pipe(
          map(currencies =>
            CurrenciesActions.loadCurrenciesSuccess({
              currencies: currencies.map((currency, index) => ({ id: index, label: currency })),
            })
          ),
          catchError(error => throwError(error))
        )
      )
    )
  );

  loadFxRatesHistories$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CurrenciesActions.loadFxRatesHistories),
      withLatestFrom(this.store.select(getFxRatesHistories)),
      switchMap(() =>
        this.smartRiskService.getFxRatesHistories().pipe(
          map(fxRatesHistories =>
            CurrenciesActions.loadFxRatesHistoriesSuccess({
              fxRatesHistories,
            })
          ),
          catchError(error => throwError(error))
        )
      )
    )
  );
}
